import { Program, GLTFLoader, Transform } from 'ogl'

import vertex from '@shaders/boat.vert'
import fragment from '@shaders/boat.frag'

export default class GLBoat {
  constructor ({ gl, parent, sceneVars, meshes }) {
    this.gl = gl
    this.parent = parent
    this.sceneVars = sceneVars
    this.meshes = meshes

    this.isActive = false
    this.lt = Math.random()
    this.ltSpeed = 0.02

    // this.createMesh()
    this.loadGLTF()
  }

  async loadGLTF () {
    const gltf = await GLTFLoader.load(this.gl, './static/models/boat-broken.glb')

    // MAIN SHIP
    this.boatMesh = gltf.meshes[0].primitives[0]
    this.boat = gltf.nodes[0]

    this.createMesh()
  }

  createMesh () {
    this.program = new Program(this.gl, {
      vertex,
      fragment,
      uniforms: {
        uAspectRatio: { value: 1 },
        uTime: { value: this.lt },
      },
    })

    this.boatMesh.program = this.program
    this.mesh = this.boat

    this.wrapper = new Transform(this.gl)

    this.wrapper.position.set(0, -1.225, -3.5)
    this.wrapper.rotation.set(Math.PI * -0.1, 0, 0)
    this.wrapper.scale.set(0.175, 0.175, 0.175)

    this.mesh.setParent(this.wrapper)
    this.wrapper.setParent(this.parent)

    this.isActive = true
  }

  // EVENT HANDLERS
  handleResize () {}

  update (t) {
    if (this.isActive) {
      this.lt += this.ltSpeed

      this.wrapper.position.y = -1.225 + Math.cos(this.lt) * 0.035
      this.wrapper.rotation.y = Math.sin(this.lt * 0.5) * 0.075
      this.wrapper.rotation.z = -0.05 + Math.cos(this.lt * 0.5) * 0.04
      this.wrapper.rotation.x = Math.sin(this.lt) * 0.05

      this.program.uniforms.uTime.value = this.lt
    }
  }
}
